<template>
  <nav id="navbar">
    <div class="logo-and-links">
      <router-link to="/">
        <img :src="logo" alt="Vispera Logo">
      </router-link>
      <el-breadcrumb v-if="showBreadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: Breadcrumbs.projects }">
          {{ $t('Projects') }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ Project.active.data.display_name }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="user">
      <el-dropdown class="user-lang" @command="handleLanguageCommands">
        <span class="el-dropdown-link">
          {{ Account.active.data.preferred_language }}
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(value, key) in languages"
                            :key="key"
                            :command="key">
            {{ value }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="user-detail" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ Account.active.data.email }}
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">
            {{ $t('Logout') }}
          </el-dropdown-item>
          <el-dropdown-item disabled>
            {{ $t('Version') }} {{ version }}
          </el-dropdown-item>
          <el-dropdown-item disabled>
            {{ timeZoneName }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </nav>
</template>

<script>
import tr from 'moment/locale/tr';
import de from 'moment/locale/de';
import pl from 'moment/locale/pl';
import ru from 'moment/locale/ru';
import pt from 'moment/locale/pt';
import da from 'moment/locale/da';
import ar from 'moment/locale/ar';
import en from 'moment/locale/en-ca';
import nb from 'moment/locale/nb';
import nn from 'moment/locale/nn';
import it from 'moment/locale/it';
import ro from 'moment/locale/ro';

import { mapState, mapActions } from 'vuex';
import { isFunction } from 'lodash';
import moment from 'moment';
import EventBus from '@/modules/global-filters/bus';
import languages from '../constants/lang';
import { version } from '../../package.json';

export default {
  name: 'Navigation',
  data() {
    return {
      languages,
      version
    };
  },
  computed: {
    ...mapState(['route', 'Account', 'Project']),
    logo() {
      return this.$route.name === this.Breadcrumbs.projects ? '/statics/logo.svg' : '/statics/blueocean_icon.svg';
    },
    showBreadcrumb() {
      return this.Project.active.data.id;
    },
    timeZoneName() {
      const options = { timeZoneName: 'short' };
      const timeZone = new Intl.DateTimeFormat(this.$i18n.locale, options).formatToParts().find(part => part.type === 'timeZoneName');

      return timeZone.value;
    }
  },
  mounted() {
    this.updateMomentLanguage(this.Account.active.data.preferred_language);
  },
  methods: {
    ...mapActions(['destroyToken', 'updateAccount']),
    getRouteName(route) {
      if (isFunction(route.bName)) {
        return route.bName(this.$store, this.$route);
      }

      return route.bName;
    },
    handleLanguageCommands(cmd) {
      this.updateMomentLanguage(cmd);
      this.updateAccount({
        data: {
          user: {
            preferred_language: cmd
          }
        }
      });
    },
    handleCommand(cmd) {
      switch (cmd) {
        case 'logout':
          localStorage.removeItem('default-filter-date');
          this.destroyToken();
          break;

        default:
          break;
      }
    },
    updateMomentLanguage(lang) {
      EventBus.$emit('language-changed', lang);
      switch (lang) {
        case 'tr':
          moment.updateLocale(lang, tr);
          break;
        case 'en':
          moment.updateLocale(lang, en);
          break;
        case 'de':
          moment.updateLocale(lang, de);
          break;
        case 'ru':
          moment.updateLocale(lang, ru);
          break;
        case 'pl':
          moment.updateLocale(lang, pl);
          break;
        case 'pt':
          moment.updateLocale(lang, pt);
          break;
        case 'da':
          moment.updateLocale(lang, da);
          break;
        case 'ar':
          moment.updateLocale(lang, ar);
          break;
        case 'no':
          moment.updateLocale(lang, nb);
          break;
        case 'nb':
          moment.updateLocale(lang, nb);
          break;
        case 'nn':
          moment.updateLocale(lang, nn);
          break;
        case 'it':
          moment.updateLocale(lang, it);
          break;
        case 'ro':
          moment.updateLocale(lang, ro);
          break;
        default:
          moment.updateLocale(lang, en);
      }
    }
  }
};
</script>

<style lang="scss">
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 55px;
  padding: 0 10px;
  font-weight: bold;
  background-color: $white;
  border-bottom: 2px solid $baiSeWhite;

  .logo-and-links {
    display: flex;
    align-items: center;

    a {
      display: block;
      height: 40px;

      img {
        height: 100%;
      }

      @include breakpoint(md-max) {
        display: none;
      }
    }

    .el-breadcrumb {
      margin-left: 20px;

      @include breakpoint(md-max) {
        margin-left: 0;
      }

      &__inner {
        font-size: 14px;

        &.is-link {
          color: $andreaBlue;
        }
      }
    }
  }

  .user {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;

    &-lang {
      margin-right: 20px;
      text-transform: uppercase;
    }
  }

  @include breakpoint(sm-max) {
    height: auto;
    padding: 10px;

    .user {
      flex-direction: row-reverse;
      justify-content: space-between;
    }

    .logo-and-links {
      display: none !important;
    }
  }
}
</style>
